import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type TrigaleDownFillProps = IconComponentBaseProps;

export const TrigaleDownFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: TrigaleDownFillProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7733_16000"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7733_16000)">
        <path
          d="M11.4911 18.7474L8.1485 14.9352C8.10254 14.8826 8.0663 14.8238 8.03978 14.7589C8.01326 14.6942 8 14.6247 8 14.5505C8 14.4023 8.04393 14.2734 8.1318 14.1639C8.21966 14.0546 8.33545 14 8.47918 14H15.5208C15.6645 14 15.7803 14.0552 15.8682 14.1657C15.9561 14.276 16 14.4048 16 14.552C16 14.5889 15.9504 14.7166 15.8512 14.9352L12.5089 18.7474C12.4322 18.8352 12.3528 18.8992 12.2708 18.9395C12.1887 18.9798 12.0985 19 12 19C11.9015 19 11.8113 18.9798 11.7292 18.9395C11.6472 18.8992 11.5678 18.8352 11.4911 18.7474Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
